import { ReactNode } from 'react';
import styleVariables from '@/styles/style.module.scss';
import { Box } from '@mui/material';

export default function LayoutSubheading({ children }: { children: ReactNode }) {
    return (
        <Box sx={{ fontWeight: '700', fontSize: '1.2rem', mb: 1.5, color: `${styleVariables.darkGrey}` }}>
            {children}
        </Box>
    );
}
